import mixpanel from 'mixpanel-browser';

export default class Analytics {

    public static init () {
        const mixpanelToken = Env.MIXPANEL_TOKEN;
        if (mixpanelToken && mixpanelToken !== '') {
            mixpanel.init(mixpanelToken, {
                api_host: 'https://api-eu.mixpanel.com',
                ignore_dnt: true,
            });
        }
    }

    public static sendEvent (name: string, properties?: any) {
        this.checkAndRun(() => mixpanel.track(name, properties || null));
    }

    public static recordPageView () {
        this.checkAndRun(() => mixpanel.track_pageview());
    }

    public static identifyUser (id: string) {
        this.checkAndRun(() => mixpanel.identify(id));
    }

    private static checkAndRun (fn: () => void) {
        try {
            fn();
        } catch (e) {
            this.init();
            fn();
        }
    }
}
